import Basket from "../../errorCodes/Basket"

export const basketErrorHandler = (errorCode: string) => {
  switch (errorCode) {
    case Basket.ItemCountLimitExceeded:
      return "errors.PBBTAItemCountLimitExceeded"
    case Basket.NotRedeemableInEventWindow:
      return "errors.PBBTANotRedeemableInEventWindow"
    case Basket.OpenValueMaxLimitExceeded:
      return "errors.PBBTAOpenValueMaxLimitExceeded"
    case Basket.OpenValueMinLimitNotReached:
      return "errors.PBBTAOpenValueMinLimitNotReached"
    case Basket.RedemptionAmountLimitExceeded:
      return "errors.PBBTARedemptionAmountLimitExceeded"
    case Basket.InvalidEntityType:
      return "errors.PBBTAInvalidEntityType"
    default:
      return ""
  }
}
